/**
 * GB Magnetic Clasp Converter — Monster Cart drawer injector
 *
 * Surfaces the Magnetic Clasp Converter bundle ($9.99) inside Monster Cart's
 * drawer when the customer has a chain/necklace/bracelet/anklet in their cart
 * but no converter yet. Monster Cart replaces the native cart drawer entirely,
 * so the Liquid snippet `gb-magnetic-clasp-cart-upsell.liquid` (which works on
 * the /cart page) never executes inside the drawer. This script bridges that
 * gap by injecting a DOM-rendered version of the same tile.
 *
 * Reads runtime config from window.gbMCUpsellConfig (rendered by Liquid in
 * snippets/gb-magnetic-clasp-mc-drawer-bootstrap.liquid). Reads cart state
 * from window.mu_cart_items (Monster Cart's internal state, kept in sync with
 * Shopify's server cart on every add/remove).
 *
 * Add-to-cart uses the `form.requestSubmit()` pattern required by Monster Cart
 * on Grace Blooms — fetch and form.submit() both break here. See
 * docs/monster-cart-integration-pattern.md.
 *
 * Failure recovery: see docs/magnetic-clasp-mc-drawer-injection.md
 */

(function () {
  'use strict';

  var CONFIG = window.gbMCUpsellConfig;
  if (!CONFIG) return;
  if (!CONFIG.goldVariantId || !CONFIG.silverVariantId) return;

  var TILE_ID = 'gb-mc-clasp-upsell-tile';
  var STYLE_ID = 'gb-mc-clasp-upsell-style';

  var eligibleSet = (CONFIG.eligibleHandles || []).reduce(function (acc, h) {
    if (h) acc[h] = true;
    return acc;
  }, {});

  var excludeSet = (CONFIG.excludeHandles || []).reduce(function (acc, h) {
    if (h) acc[h] = true;
    return acc;
  }, {});

  function getMCCartItems() {
    if (Array.isArray(window.mu_cart_items)) return window.mu_cart_items;
    if (window.monster_getCartItems) {
      try { return window.monster_getCartItems() || []; } catch (e) { return []; }
    }
    return [];
  }

  function isEligible(items) {
    if (!items || !items.length) return false;
    var hasEligible = false;
    for (var i = 0; i < items.length; i++) {
      var handle = items[i].handle || items[i].product_handle || '';
      if (excludeSet[handle]) return false;
      if (eligibleSet[handle]) hasEligible = true;
    }
    return hasEligible;
  }

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '#' + TILE_ID + '{display:flex;gap:14px;align-items:flex-start;background:linear-gradient(180deg,#fbf8f3 0%,#f5efe3 100%);border:1px solid #d4cfc8;border-radius:6px;padding:14px 16px;margin:12px 14px;font-family:inherit;}',
      '#' + TILE_ID + ' .gb-mc-img-wrap{flex:0 0 80px;width:80px;height:80px;background:#fff;border-radius:4px;overflow:hidden;position:relative;}',
      '#' + TILE_ID + ' .gb-mc-img-wrap img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;}',
      '#' + TILE_ID + ' .gb-mc-img-wrap img[hidden]{display:none;}',
      '#' + TILE_ID + ' .gb-mc-body{flex:1;min-width:0;}',
      '#' + TILE_ID + ' .gb-mc-title{font-size:14px;font-weight:600;margin:0 0 2px;color:#1a1817;line-height:1.3;}',
      '#' + TILE_ID + ' .gb-mc-sub{font-size:12px;color:#4a4641;margin:0 0 6px;line-height:1.4;}',
      '#' + TILE_ID + ' .gb-mc-price-row{display:flex;align-items:baseline;gap:8px;margin-bottom:10px;flex-wrap:wrap;}',
      '#' + TILE_ID + ' .gb-mc-price{font-size:15px;font-weight:700;color:#1a1817;}',
      '#' + TILE_ID + ' .gb-mc-strike{font-size:12px;color:#8a8278;text-decoration:line-through;}',
      '#' + TILE_ID + ' .gb-mc-save{font-size:11px;color:#7a5a2f;background:#f2ece0;padding:2px 8px;border-radius:99px;letter-spacing:0.04em;text-transform:uppercase;font-weight:600;}',
      '#' + TILE_ID + ' .gb-mc-tones{display:flex;gap:6px;margin-bottom:8px;}',
      '#' + TILE_ID + ' .gb-mc-tone{flex:1;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:12px;letter-spacing:0.04em;padding:7px 10px;border:1px solid #c9c2b7;border-radius:2px;background:#fff;color:#4a4641;font-weight:500;transition:border-color 120ms ease,color 120ms ease,background 120ms ease;}',
      '#' + TILE_ID + ' .gb-mc-tone.is-selected{border-color:#1a1817;background:#1a1817;color:#fff;font-weight:600;}',
      '#' + TILE_ID + ' .gb-mc-tone:hover{border-color:#1a1817;}',
      '#' + TILE_ID + ' .gb-mc-cta{width:100%;background:#1a1817;color:#fff;padding:9px 16px;border-radius:2px;font-size:13px;letter-spacing:0.04em;border:none;cursor:pointer;font-family:inherit;font-weight:600;}',
      '#' + TILE_ID + ' .gb-mc-cta:hover{opacity:0.92;}',
      '#' + TILE_ID + ' .gb-mc-cta[disabled]{opacity:0.6;cursor:wait;}',
      '#' + TILE_ID + ' .gb-mc-micro{font-size:11px;color:#7d6f5a;margin:6px 0 0;font-style:italic;text-align:center;}'
    ].join('');
    document.head.appendChild(style);
  }

  function el(tag, className, attrs) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (attrs) {
      for (var k in attrs) {
        if (Object.prototype.hasOwnProperty.call(attrs, k)) node.setAttribute(k, attrs[k]);
      }
    }
    return node;
  }

  function buildTile() {
    var tile = el('div', null, { id: TILE_ID, 'data-gb-mc-injected': 'true' });

    var imgWrap = el('div', 'gb-mc-img-wrap');
    if (CONFIG.goldImage) {
      var imgG = el('img', null, {
        src: CONFIG.goldImage,
        alt: 'Magnetic Clasp Converter — Gold',
        loading: 'lazy',
        'data-tone': 'gold'
      });
      imgWrap.appendChild(imgG);
    }
    if (CONFIG.silverImage) {
      var imgS = el('img', null, {
        src: CONFIG.silverImage,
        alt: 'Magnetic Clasp Converter — Silver',
        loading: 'lazy',
        'data-tone': 'silver',
        hidden: 'hidden'
      });
      imgWrap.appendChild(imgS);
    }
    tile.appendChild(imgWrap);

    var body = el('div', 'gb-mc-body');

    var title = el('p', 'gb-mc-title');
    title.textContent = 'Add the Magnetic Clasp Converter';
    body.appendChild(title);

    var sub = el('p', 'gb-mc-sub');
    sub.textContent = 'The little clasp that lets you put it on yourself.';
    body.appendChild(sub);

    var priceRow = el('div', 'gb-mc-price-row');
    var price = el('span', 'gb-mc-price');
    price.textContent = '$9.99';
    var strike = el('span', 'gb-mc-strike');
    strike.textContent = '$14.99';
    var save = el('span', 'gb-mc-save');
    save.textContent = 'save $5';
    priceRow.appendChild(price);
    priceRow.appendChild(strike);
    priceRow.appendChild(save);
    body.appendChild(priceRow);

    var tones = el('div', 'gb-mc-tones', { role: 'radiogroup', 'aria-label': 'Choose tone' });
    var goldBtn = el('button', 'gb-mc-tone is-selected', { type: 'button', 'data-tone': 'gold', 'aria-pressed': 'true' });
    goldBtn.textContent = 'Gold';
    var silverBtn = el('button', 'gb-mc-tone', { type: 'button', 'data-tone': 'silver', 'aria-pressed': 'false' });
    silverBtn.textContent = 'Silver';
    tones.appendChild(goldBtn);
    tones.appendChild(silverBtn);
    body.appendChild(tones);

    var cta = el('button', 'gb-mc-cta', { type: 'button', 'data-action': 'add' });
    cta.textContent = 'Add to my order';
    body.appendChild(cta);

    var micro = el('p', 'gb-mc-micro');
    micro.textContent = 'Most popular add-on · Works on the piece in your cart';
    body.appendChild(micro);

    tile.appendChild(body);

    wireTile(tile);
    return tile;
  }

  function wireTile(tile) {
    var toneBtns = tile.querySelectorAll('.gb-mc-tone');
    var imgs = tile.querySelectorAll('.gb-mc-img-wrap img');
    var cta = tile.querySelector('.gb-mc-cta');
    var selectedTone = 'gold';

    toneBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectedTone = btn.getAttribute('data-tone');
        toneBtns.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        imgs.forEach(function (img) {
          img.hidden = img.getAttribute('data-tone') !== selectedTone;
        });
      });
    });

    cta.addEventListener('click', function () {
      var variantId = selectedTone === 'silver' ? CONFIG.silverVariantId : CONFIG.goldVariantId;
      addToCartViaFormRequestSubmit(variantId, cta);
    });
  }

  /**
   * Adds a variant to cart using the form.requestSubmit() pattern required by
   * Monster Cart on Grace Blooms. Documented in
   * docs/monster-cart-integration-pattern.md — DO NOT switch to fetch.
   */
  function addToCartViaFormRequestSubmit(variantId, cta) {
    if (!variantId) return;
    cta.disabled = true;
    cta.textContent = 'Adding…';

    var form = document.createElement('form');
    form.action = '/cart/add';
    form.method = 'POST';
    form.enctype = 'multipart/form-data';
    form.style.display = 'none';

    var idInput = document.createElement('input');
    idInput.type = 'hidden';
    idInput.name = 'id';
    idInput.value = String(variantId);
    form.appendChild(idInput);

    var qtyInput = document.createElement('input');
    qtyInput.type = 'hidden';
    qtyInput.name = 'quantity';
    qtyInput.value = '1';
    form.appendChild(qtyInput);

    document.body.appendChild(form);
    form.requestSubmit();

    setTimeout(function () {
      try { form.parentNode && form.parentNode.removeChild(form); } catch (e) {}
    }, 3000);
  }

  function findInjectionAnchor(drawer) {
    // Try in priority order; the first one that exists wins.
    // Insert BEFORE the FBT upsell rail when possible so our tile sits above
    // Monster Cart's native "Frequently Bought Together" cards.
    var selectors = [
      '.mu-upsell-cart',  // FBT rail — preferred anchor
      '.mu-cart-foot',    // footer with totals + checkout
      '.mu-cart-bottom',
      '.mu-cart-items',   // line items list
      '.mu-cart-body'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = drawer.querySelector(selectors[i]);
      if (el) return { el: el, mode: i <= 2 ? 'before' : 'append' };
    }
    return { el: drawer, mode: 'append' };
  }

  function syncTile() {
    var drawer = document.getElementById('monster-cart-wrapper');
    if (!drawer) return;

    var items = getMCCartItems();
    var eligible = isEligible(items);
    var existing = document.getElementById(TILE_ID);

    if (!eligible) {
      if (existing) existing.remove();
      return;
    }

    if (existing && drawer.contains(existing)) return;
    if (existing) existing.remove();

    ensureStyles();
    var tile = buildTile();
    var anchor = findInjectionAnchor(drawer);
    if (anchor.mode === 'before' && anchor.el.parentNode) {
      anchor.el.parentNode.insertBefore(tile, anchor.el);
    } else {
      anchor.el.appendChild(tile);
    }
  }

  var wrapperObs = null;

  function attachWrapperObserver() {
    var drawer = document.getElementById('monster-cart-wrapper');
    if (!drawer || wrapperObs) return;
    wrapperObs = new MutationObserver(function () { syncTile(); });
    wrapperObs.observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    syncTile();
  }

  function init() {
    attachWrapperObserver();
    var bodyObs = new MutationObserver(function () {
      if (!wrapperObs && document.getElementById('monster-cart-wrapper')) {
        attachWrapperObserver();
      }
    });
    bodyObs.observe(document.body, { childList: true, subtree: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if (window.requestIdleCallback) window.requestIdleCallback(init, { timeout: 2000 });
      else setTimeout(init, 800);
    });
  } else {
    if (window.requestIdleCallback) window.requestIdleCallback(init, { timeout: 2000 });
    else setTimeout(init, 800);
  }
})();
